import { array, number, object, string } from "yup";

export default object().shape({
  company: object()
    .shape({
      name: string().required("Required"),
    })
    .required("Required"),
  portfolio: object()
    .shape({
      id: number().required("Required"),
    })
    .required("Required"),
  assets: array()
    .of(
      object().shape({
        id: number().required("Required"),
      })
    )
    .min(1)
    .required("Required"),
  user: object()
    .shape({
      name: string().required("Required"),
      email: string().email("Email").required("Required"),
    })
    .required("Required"),
});
